// Ignores new DB data in order to give websockets priority
export const mergeById = (old_array, new_array) => {
    let ids = old_array.map(item => item.id)

    new_array = new_array.filter(item => item != undefined) //removes empty items

    if (!new_array.length) return old_array
    
    let draft_array = new_array.filter(item => {
        return (ids.indexOf(item.id) == -1 || (!ids.length))
    })

    return old_array.concat(draft_array).sort((a, b) => (-(a.id - b.id)))
}


export const mergeByIdReplaceOldWithNew = (old_array, new_array) => {
    new_array = new_array.filter(item => item != undefined) //removes empty items

    if (!new_array.length) return old_array

    let return_array = [...new_array, ...old_array]
    return removeDuplicates(return_array, 'id')
}


export const createCookie = (name,value,minutes) => {
    var expires = "";
    if (minutes) {
        var date = new Date();
        date.setTime(date.getTime() + (minutes*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
};

export const readCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
};

export const makeGetString = (request) => {
    var str = [];
    for(var p in request) {
        if (request.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(request[p]));
        }
    }
    return '?' + str.join("&");
}


export const removeDuplicates = (myArr, prop) => {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
};
        let matched = false


export const nl2br = (text) => {
    return String(text).replace(/\n/g,"<br />")
}

export const addEllipsis = (text, length, height = 0) => {
    if (text) {
        if (height && (text.match(/[\n]/g) || []).length >= height) {
            let pos = -1,
                iteration = 0,
                temp_string = text

            for (let x = 1; x < text.length; x++) {
                if (temp_string.indexOf('\n') >= 0) {
                    iteration ++
                    if (iteration == height-1) {
                        pos = temp_string.indexOf('\n')
                        break
                    }
                    temp_string = temp_string.replace("\n", "--")
                }
            }

            if (pos > -1) {
                return text.substr(0,pos) + '...'
            }
        }
        if (text.length > length) {
            let cut_str = text.substr(0, length)
            if (cut_str.lastIndexOf(' ') > 0) {
                return cut_str.substr(0, text.lastIndexOf(' ')) + '...'
            }
            return cut_str +  '...'
        }
        return text
    }
}

// only run a function if it hasn't run for [threshhold] milliseconds
export const throttle = function(callback, limit) {

  var wait = false;
  return function () {
    if (!wait) {

      callback.apply(null, arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  }
}

export const stringToSlug = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str
}

export const formatPrice = (price = 0, decimals = 2, currency_symbol = 'R') => {
    let rounded_price = Math.floor(price * 100)/100
    if (decimals > 0) {
        return currency_symbol + ' ' + (rounded_price.toLocaleString('en', {minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping:' '})).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return currency_symbol + ' ' + rounded_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


// WEBPACK FOOTER //
// ./assets/js/vue/helpers/_main.js